import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { initTelemetry } from './app/telemetry';
import { environment } from '@environments/environment';

if (environment.production) enableProdMode();

initTelemetry(
	environment.telemetryAppName,
	environment.appVersion,
	environment.telemetryEnvironment
);

platformBrowserDynamic().bootstrapModule(AppModule).catch(console.error);
